{
  "pages": {
    "tickets": {
      "title": "Tickets",
      "allTickets": "All Tickets",
      "actions": {
        "new": "New Ticket",
        "create": "Create Ticket",
        "edit": "Edit Ticket"
      },
      "tabs": {
        "active": "Active",
        "archived": "Archived"
      }
    }
  },
  "components": {
    "ticketsTable": {
      "columns": {
        "number": "Number",
        "ticketNumber": "Ticket #",
        "status": "Status",
        "subStatus": "Sub Status",
        "type": "Type",
        "subject": "Subject",
        "organization": "Organization",
        "reporter": "Reporter",
        "createdBy": "Created by",
        "assignedTo": "Assigned to",
        "priority": "Priority",
        "label": "Label",
        "vendor": "Vendor",
        "location": "Location / property",
        "address": "Address",
        "city": "City",
        "state": "State",
        "zip": "Zip",
        "created": "Created on",
        "lastUpdate": "Updated on",
        "dueDate": "Due date",
        "lastEdited": "Last edited",
        "internalOnly": "Internal only"
      },
      "filters": {
        "search": "Search tickets...",
        "status": "All Statuses",
        "type": "All Types",
        "priority": "All Priorities"
      }
    },
    "noData": {
      "title": "No tickets have been created yet",
      "description": "No tickets have been created yet, you can create them by clicking the button in the top right corner."
    },
    "createTicketForm": {
      "title": "Create ticket",
      "fields": {
        "subject": "Subject",
        "description": "Description"
      },
      "success": {
        "message": "Ticket created successfully"
      },
      "error": {
        "message": "Failed to create ticket"
      },
      "errors": {
        "maxFiles": "You can upload up to {{maxFiles}} files.",
        "maxSize": "Total file size must not exceed {{maxSize}} MB."
      }
    },
    "ticketDetails": {
      "title": "Ticket {{number}}",
      "editTicket": "Edit ticket",
      "logForm": {
        "addComment": "Add comment",
        "noLogs": {
          "description": "No comments to display in this ticket, add one above."
        }
      },
      "attachmentsForm": {
        "fileRequired": "At least one file is required.",
        "uploadFiles": "Upload files",
        "noDocuments": {
          "description": "No documents to display in this ticket"
        }
      },
      "preview": {
        "back": "Back to ticket details"
      },
      "subject": {
        "dueDate": "Due date",
        "category": "Category",
        "status": "Status",
        "subject": "Subject"
      },
      "description": {
        "description": "Description",
        "assignedTo": "Assigned to"
      },
      "fields": {
        "title": "Title",
        "accessType": "Type"
      },
      "tabs": {
        "ticketDetails": "Ticket Details",
        "comments": "Comments",
        "activityLog": "Activity Log",
        "logs": "Logs",
        "documents": "Documents"
      },
      "comments": {
        "internalComment": "Internal comment",
        "newComment": "New comment",
        "markAsInternal": "Mark as Internal",
        "yourComment": "Your comment",
        "placeholder": "Write a comment...",
        "emptyList": "No comments to display in this ticket."
      },
      "activityLog": {
        "empty": "No activity to display for this ticket.",
        "fields": {
          "subject": "Title",
          "description": "Description",
          "status": "Status",
          "priority": "Priority",
          "category": "Type",
          "subCategory": "Sub type",
          "phoneNumber": "Phone number",
          "vendorName": "Vendor name",
          "location": "Location",
          "assignee": "Assignee",
          "dueDate": "Due date",
          "followUpDate": "Follow-up date",
          "accessType": "Access type",
          "zip": "Zip",
          "state": "State",
          "address": "Address",
          "city": "City",
          "subStatus": "Sub status",
          "savingsAmount": "Savings amount",
          "organization": "Organization",
          "vendor": "Vendor",
          "project": "Project",
          "ticketNumber": "Ticket number",
          "comment": "Comment",
          "deletedAt": "Deleted at",
          "document": "Document",
          "externalUser": "External user",
          "filename": "Filename",
          "isParticipant": "Participant",
          "receiveEmailNotifications": "Email notifications",
          "scope": "Scope",
          "ticket": "Ticket",
          "ticketFile": "File"
        },
        "actions": {
          "fieldChanged": "{{fieldLabel}} was changed from <strong>{{oldValue}}</strong> to <strong>{{newValue}}</strong>",
          "ticketCreated": "Ticket was <strong>created</strong>",
          "commentAdded": "Comment <strong>{{name}}</strong> was added",
          "commentDeleted": "Comment <strong>{{name}}</strong> was deleted",
          "fileAdded": "File <strong>{{name}}</strong> was added",
          "fileDeleted": "File <strong>{{name}}</strong> was deleted"
        }
      }
    },
    "ticketListItem": {
      "fields": {
        "ticket": "Ticket",
        "status": "Status",
        "type": "Type",
        "priority": "Priority",
        "assigned": "Assigned person",
        "receiveEmailUpdates": "Receive e-mail updates",
        "internalOnly": "Set as internal only",
        "note": "Note",
        "savingsAmount": "Savings Amount",
        "savingsAmountPlaceholder": "Enter savings amount...",
        "contacts": {
          "label": "Contacts",
          "placeholder": "Select contacts..."
        },
        "notifiedUsers": {
          "label": "Notify users",
          "placeholder": "Select users to notify..."
        },
        "reporter": "Reporter",
        "location": "Location",
        "assignee": "Assignee"
      },
      "comments": {
        "internal": "Internal",
        "internalComment": "Internal comment"
      },
      "documents": {
        "title": "Documents",
        "emptyListMessage": "No documents to display in this ticket"
      },
      "note": {
        "addNote": "Add note",
        "placeholder": "Write a note...",
        "sendAsInternal": "Send as internal",
        "sendAsInternalDescription": "By sending it as internal, only other SIB employees will see your note. It will be invisible to other users.",
        "label": "Note",
        "save": "Save note"
      },
      "accessType": {
        "standard": "Standard",
        "internal": "Internal"
      }
    },
    "ticketsList": {
      "yourTickets": "Your Tickets",
      "searchPlaceholder": "Find by name",
      "noData": {
        "noTickets": "No tickets found.",
        "noTicketsWithSearch": "There are no results for the phrase you are looking for. Please use another phrase and try again",
        "emptyListMessage": "It looks like you don't have any tickets in this section yet.",
        "noTicketsList": {
          "title": "No tickets found.",
          "description": "No tickets to display, try adjusting the filters to find relevant results."
        }
      },
      "assigneeTicketsSection": {
        "assigneeTickets_one": "{{count}} Assigned tickets",
        "assigneeTickets_other": "{{count}} Assigned tickets"
      },
      "groupAndSort": {
        "label": "Grouping & sorting",

        "sortByList": {
          "priority": "Priority",
          "title": "Title",
          "status": "Status",
          "lastEdited": "Last edited"
        },
        "groupByList": {
          "organization": "Organization",
          "assignee": "Assignee",
          "type": "Type"
        },
        "groupedByLastUpdated": {
          "recentlyUpdated": "Recently updated",
          "previouslyUpdated": "Previously updated (2 days +)"
        }
      },
      "ticketCount_one": "{{count}} ticket",
      "ticketCount_other": "{{count}} tickets"
    },
    "ticketForm": {
      "fields": {
        "subject": "Subject",
        "description": "Description",
        "organization": {
          "label": "Organization",
          "searchPlaceholder": "Search for organization..."
        },
        "status": "Status",
        "priority": "Priority",
        "type": "Type",
        "assignedTo": "Assigned to",
        "author": "Author",
        "contacts": "Contacts",
        "attachments": "Attachments",
        "dueDate": "Due Date",
        "setAsInternal": "Set as internal only"
      },
      "submit": {
        "update": "Update Ticket",
        "create": "Create Ticket"
      },
      "warnings": {
        "vectorOrganization": {
          "title": "Ticket creation unavailable",
          "message": "Ticket creation is temporarily unavailable for Vector organizations. Please select a different organization or contact support for assistance."
        }
      }
    }
  },
  "enums": {
    "ticketStatus": {
      "new": "New",
      "inProgress": "In progress",
      "closed": "Closed",
      "workingWithVendor": "Working with Vendor",
      "awaitingClientAction": "Awaiting Client Action",
      "awaitingInternalAction": "Awaiting Internal Action",
      "canceled": "Canceled",
      "completed": "Completed",
      "active": "Active",
      "unassigned": "Unassigned",
      "resolved": "Resolved"
    },
    "ticketType": {
      "account": "Account",
      "baselines": "Baselines",
      "client": "Client",
      "contract": "Contract",
      "customerService": "Customer Service",
      "escalation": "Escalation",
      "exceptions": "Exceptions",
      "finance": "Finance",
      "followUp": "Follow Up",
      "informationRequest": "Information Request",
      "invoice": "Invoice",
      "masterData": "Master Data",
      "negotiation": "Negotiation",
      "others": "Others",
      "payments": "Payments",
      "property": "Property",
      "serviceRequest": "Service Request",
      "transitions": "Transitions",
      "vendorLocal": "Vendor Local",
      "missingBill": "Missing Bill",
      "updateMailingAddress": "Update Mailing Address",
      "potentialLeak": "Potential Leak",
      "invoiceQuestion": "Invoice Question"
    },
    "ticketPriority": {
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    }
  },
  "notifications": {
    "success": {
      "TICKET_CREATION_SUCCESS": {
        "description": "Ticket has been created successfully"
      },
      "TICKET_EDITION_SUCCESS": {
        "description": "Ticket has been updated successfully"
      },
      "TICKET_FILE_MOVE_SUCCESS": {
        "description": "File has been moved to the document repository successfully"
      },
      "TICKET_FILE_REMOVE_SUCCESS": {
        "description": "File has been removed from the document repository successfully"
      },
      "TICKET_FILE_DELETE_SUCCESS": {
        "description": "File has been deleted from the ticket successfully"
      }
    }
  }
}
